// 项目共享通用工具函数
export function formatDate(date: Date): string {
  return date.toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

// Type checking functions moved from web/utils/is.ts
export function isArray(val: any): boolean {
  return Object.prototype.toString.call(val) === "[object Array]";
}

export function isObject(val: any): boolean {
  return Object.prototype.toString.call(val) === "[object Object]";
}

export function isString(val: any): boolean {
  return Object.prototype.toString.call(val) === "[object String]";
}

export const isSSR = (function () {
  try {
    return !(typeof window !== "undefined" && document !== undefined);
  } catch (e) {
    return true;
  }
})();
